
const _ = require('lodash');

import ko from 'rgs-knockout';
const kv = require('knockout.validation');


kv.computedGroup = function (compute, options) {
	const group = _.extend(ko.pureComputed(function () {
		if (group && group.peek()) {
			group.peek().dispose();
		}
		return kv.group(compute(), _.extend({ deep: true }, options));
	}), {
		compute: compute,
	});

	return group;
};

kv.firstInvalid = function (validated) {
	/*
	 * Given an array of validated observables, find the first invalid
	 * and return it.
	 */

	if (!validated) {
		return null;
	}
	if (!_.isArray(validated)) {
		validated = [validated];
	}
	if (!validated.length) {
		return null;
	}

	return _.find(_.filter(validated), obs => {
		if (!obs.error) {
			return false;
		}

		const modified = !obs.isModified || obs.isModified();

		if (!modified) {
			return false;
		}

		const err = obs.error();

		if (!err) {
			return false;
		}

		return true;
	});
};

kv.firstError = function (validated) {
	/*
	 * Given an array of validated observables, find the first invalid
	 * and return it's error message.
	 */

	return kv.firstInvalid(validated).error();
};


module.exports = kv;

